import React, { useEffect, useState, useMemo } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { format } from 'date-fns';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { useSelector } from 'react-redux';
import Button from '../Button';
import DatePickerCalander from '../../Utilities/DatePickerCalander';
import useFormValidation from '../../hooks/zodFormValidation';
import appSchema from '../../schema/appSchema';
import { getMaskPhone } from '../../Utilities/Utilities';

function PatientDemoPopUp({ handleClose }) {
  const { user } = useSelector((state) => state.auth);

  const [allCountery, setAllCountery] = useState([]);
  const [allStateList, setAllStateList] = useState([]);
  const [allState, setAllState] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dobDate, setDobDate] = useState('');
  const [patDemoGender, setPatDemoGender] = useState('male');
  const [patDemoHomePhone, setPatDemoHomePhone] = useState('');
  const [patDemoMobilePhone, setPatDemoMobilePhone] = useState('');

  const [patDemoAddrOne, setPatDemoAddrOne] = useState('');
  const [patDemoAddrTwo, setPatDemoAddrTwo] = useState('');
  const [patDemoCity, setPatDemoCity] = useState('');

  const [patDemoZip, setPatDemoZip] = useState('');

  const [state, setState] = useState('');
  const [countery, setCountery] = useState(223);

  const [patDemoEmail, setPatDemoEmail] = useState('');

  const [onboardRequest, setOnboardRequest] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const schema = useMemo(() => appSchema?.addPatientSchema?.() || null, []);

  const formData = useMemo(
    () => ({
      firstName,
      lastName,
      dobDate,
      patDemoGender,
      patDemoHomePhone,
      patDemoMobilePhone,
      patDemoZip,
      patDemoEmail,
    }),
    [
      firstName,
      lastName,
      dobDate,
      patDemoGender,
      patDemoHomePhone,
      patDemoMobilePhone,
      patDemoZip,
      patDemoEmail,
    ],
  );

  const { errors, validateForm } = useFormValidation({
    schema,
    formData,
    isSubmit,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await post('/api/patient/patient/openNewPatDemo', {});

        if (response?.status === 200) {
          setAllStateList(response?.data?.allState || []);
          setAllCountery(response?.data?.allCountery || []);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };
    fetchData();
  }, []);

  const handleSavePatient = async () => {
    setIsSubmit(true);
    const validationError = validateForm();
    if (validationError) return;

    try {
      const response = await post('api/patient/patient/savePatientDemo', {
        first_name: firstName,
        middle_name: middleName,
        last_name: lastName,
        date_of_birth: dobDate && format(dobDate, 'yyyy-MM-dd'),
        gender: patDemoGender,
        mobile: patDemoMobilePhone,
        home_phone: patDemoHomePhone,
        address: patDemoAddrOne,
        correspondence_address: patDemoAddrTwo,
        city: patDemoCity,
        state: state,
        country: countery,
        zip: patDemoZip,
        email: patDemoEmail,
        loginUserId: user?.id,
        onboard: onboardRequest ? '1' : '0',
      });

      if (response?.status === 200) {
        if (response?.data?.successCode === '1') {
          setUiMessage('suc', response?.data?.successMsg);
          handleClose();
        } else {
          setUiMessage('err', response?.data?.errorMsg);
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  useEffect(() => {
    setAllState(allStateList[countery] || []);
  }, [allStateList, countery]);

  return (
    <div className="modalBackground">
      <div className="sp-demo-cntnr shadow" id="patDemoPopContainer">
        {' '}
        <div
          className="prgrs-tmplt-hdr width100 flex-sec justify-between item-center"
          style={{ paddingLeft: '15px' }}
        >
          <span className="tmplt-hdr-hdng" id="">
            Add New Patient
          </span>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="sp-dm-bdy" style={{ display: 'flex' }}>
          <div className="sp-dem-rw-lft">
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                First Name:
                <span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <input
                  name="PatDemoFname"
                  id="PatDemoFname"
                  type="text"
                  className="sp-dm-vl-inpt"
                  placeholder=""
                  value={firstName}
                  onChange={(e) => setFirstName(e.target?.value)}
                />
                {errors?.firstName && (
                  <span className="error-msg">
                    {errors?.firstName?.message}
                  </span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Middle Name:</span>
              <span className="sp-dm-vl">
                <input
                  name="PatDemoMname"
                  id="PatDemoMname"
                  type="text"
                  className="sp-dm-vl-inpt"
                  placeholder=""
                  value={middleName}
                  onChange={(e) => setMiddleName(e.target?.value)}
                />
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                Last Name:<span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <input
                  name="PatDemoLname"
                  id="PatDemoLname"
                  type="text"
                  className="sp-dm-vl-inpt"
                  placeholder=""
                  value={lastName}
                  onChange={(e) => setLastName(e.target?.value)}
                />
                {errors?.lastName && (
                  <span className="error-msg">{errors?.lastName?.message}</span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl" qstyle={{ width: '147%' }}>
                DOB:<span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <DatePickerCalander
                  selectedDate={dobDate || null}
                  setSelectedDate={(date) => setDobDate(date)}
                  className="new-patient-dob"
                  dateFormat={DEFAULT_DATE_FORMATE}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  style={{
                    width: '100px',
                    paddingLeft: '6px',
                  }}
                  maxDate={new Date()}
                  minDate={new Date(new Date().getFullYear() - 120, 0, 1)} // 120 yrs ago
                />
                {errors?.dobDate && (
                  <span className="error-msg">{errors?.dobDate?.message}</span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                Sex:<span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <select
                  className="book-appt-dd"
                  placeholder="Select Gender"
                  value={patDemoGender}
                  onChange={(e) => setPatDemoGender(e.target.value)}
                  style={{
                    width: '159px',
                    paddingLeft: '6px',
                  }}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="decline">Decline</option>
                  <option value="unknown">Unknown</option>
                  <option value="other">Other</option>
                </select>
                {errors?.patDemoGender && (
                  <span className="error-msg">
                    {errors?.patDemoGender?.message}
                  </span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                Home Phone:<span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="(000) 000-0000"
                  value={patDemoHomePhone}
                  onChange={(e) =>
                    setPatDemoHomePhone(getMaskPhone(e.target.value))
                  }
                  maxLength={14}
                  inputMode="numeric"
                />
                {errors?.patDemoHomePhone && (
                  <span className="error-msg">
                    {errors?.patDemoHomePhone?.message}
                  </span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Mobile Phone:</span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="(000) 000-0000"
                  value={patDemoMobilePhone}
                  onChange={(e) =>
                    setPatDemoMobilePhone(getMaskPhone(e.target.value))
                  }
                  maxLength={14}
                  inputMode="numeric"
                />
              </span>
            </div>
          </div>
          <div className="sp-dem-rw-rt">
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Address 1:</span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoAddrOne}
                  onChange={(e) => setPatDemoAddrOne(e.target.value)}
                />
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Address 2:</span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoAddrTwo}
                  onChange={(e) => setPatDemoAddrTwo(e.target.value)}
                />
              </span>
            </div>

            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl ">City:</span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoCity}
                  onChange={(e) => setPatDemoCity(e.target.value)}
                />
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">State:</span>
              <span className="sp-dm-vl">
                <select
                  className="chzn-select sp-dm-vl-slct chzn-done"
                  id="PatDemoState"
                  name="PatDemoState"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  style={{ width: '159px', paddingLeft: '6px' }}
                >
                  <option value="">Select state</option>
                  {allState[0]?.length > 0 &&
                    allState[0]?.map((item, i) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.state_name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                Zip:<span className="required-fld">*</span>
              </span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoZip}
                  onChange={(e) => setPatDemoZip(e.target.value)}
                />
                {errors?.patDemoZip && (
                  <span className="error-msg">
                    {errors?.patDemoZip?.message}
                  </span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Country:</span>
              <span className="sp-dm-vl">
                <select
                  value={countery}
                  onChange={(e) => setCountery(e.target.value)}
                  style={{ width: '159px', paddingLeft: '6px' }}
                >
                  <option value="">Select countery</option>
                  {allCountery &&
                    allCountery?.map((item, i) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.country_name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">Email ID:</span>
              <span className="sp-dm-vl">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoEmail}
                  onChange={(e) => setPatDemoEmail(e.target.value)}
                />
                {errors?.patDemoEmail && (
                  <span className="error-msg">
                    {errors?.patDemoEmail?.message}
                  </span>
                )}
              </span>
            </div>
            <div className="sp-dem-rw flex-sec">
              <span className="sp-dm-lbl">
                Send Patient Portal (PP) Invite for Onboarding:
              </span>
              <span className="sp-dm-vl">
                <input
                  type="checkbox"
                  className="inpt-width"
                  placeholder=""
                  value={onboardRequest}
                  checked={onboardRequest}
                  onChange={(e) => setOnboardRequest(e.target.checked)}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="prgrs-tmplt-btn flex-sec justify-end item-center gap10">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSavePatient}
            disabled={Object.keys(errors).length > 0}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PatientDemoPopUp;
